import { render } from "./store-notify.vue?vue&type=template&id=1c9f5d4c&scoped=true"
import script from "./store-notify.vue?vue&type=script&lang=js"
export * from "./store-notify.vue?vue&type=script&lang=js"

import "./store-notify.vue?vue&type=style&index=0&id=1c9f5d4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9f5d4c"]])

export default __exports__